var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZjhdcs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "97.3043291%",
    id: "olhrtf0xgc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC51",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E13",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "ooppljdhjb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD84",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6BB63",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.0784394%",
    y1: "25.2220072%",
    x2: "91.088602%",
    y2: "76.6881963%",
    id: "hkalc9aa9d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "bz9waa2p8a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bz9waa2p8a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,8 C34.3506307,8 40.0997889,10.5891359 44.2614593,14.7744092 C48.4251707,18.9617352 51,24.7466044 51,31.1361163 C51,36.6616494 47.5782888,43.4412816 43.3475291,49.410863 C37.7842583,57.2606113 30.7296255,64 28,64 C25.2703745,64 18.2157417,57.2606113 12.6524709,49.410863 C8.42171119,43.4412816 5,36.6616494 5,31.1361163 C5,24.7466044 7.57482926,18.9617352 11.7385407,14.7744092 C15.9002111,10.5891359 21.6493693,8 28,8 Z",
    stroke: "url(#ooppljdhjb)",
    strokeWidth: 2,
    fill: "url(#olhrtf0xgc)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65456623,12.4481999 L12.0513683,8.92307692 L14.5656435,8.92307692 L19.9636987,12.4482261 L19.9636987,22.3076923 L16.041103,22.3076923 L16.041103,18.7606454 C16.041103,17.2856458 14.8119622,16.0790183 13.3092791,16.0790183 L13.3080526,16.0790183 C11.8056628,16.0790183 10.5759087,17.2856458 10.5759087,18.7606454 L10.5759087,22.3076923 L6.65456623,22.3076923 L6.65456623,12.4481999 Z",
    fill: "#FFF",
    transform: "translate(15.799962 17.437179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4142398,2.75908525 L12.0370181,2.75908525 L12.0370181,0 L14.5805995,0 L14.5805995,2.75908525 L17.2040251,2.75908525 L17.2040251,5.43582332 L14.5805995,5.43582332 L14.5805995,8.19488022 L12.0370181,8.19488022 L12.0370181,5.43582332 L9.4142398,5.43582332 L9.4142398,2.75908525 Z M0.363129862,16.3568159 C0.182185356,16.4417737 0,16.5307325 0,16.7394949 L0,21.925666 C0,22.1344851 0.162790729,22.3076923 0.363129862,22.3076923 L5.19298342,22.3076923 L5.19298342,14.0627852 L0.363129862,16.3568159 Z M26.2551351,16.3568159 C26.4354592,16.4417737 26.6182649,16.5307325 26.6182649,16.7394949 L26.6182649,21.925666 C26.6182649,22.1344851 26.4555012,22.3076923 26.2551351,22.3076923 L21.4252815,22.3076923 L21.4252815,14.0627852 L26.2551351,16.3568159 Z",
    fill: "url(#hkalc9aa9d)",
    transform: "translate(15.799962 17.437179)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZjhdcs);
export default __webpack_public_path__ + "static/media/zjhdcs.6a6a388c99e34662440d2f6a524511e3.svg";
export { ForwardRef as ReactComponent };